import CrmTabNavigator from './crm-tab-navigator'
export { CrmTabNavigator }
